<template>
    <evp-layout>
        <navigation-header
            :return-url="route('home')"
            :title="$t('global.AppTitle')"
        />

        <a v-if="isAndroid" href="https://play.google.com/store/apps/details?id=lv.meditec.ehealthpoint&hl=en&utm_source=eveselibaspunkts.lv&utm_campaign=AppLanding&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" class="button-secondary h-11 relative z-20 my-1 justify-start">
            <svg
                class="h-8 mx-1.5"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                baseProfile="full"
                viewBox="0 0 76.00 76.00"
                enable-background="new 0 0 76.00 76.00"
                xml:space="preserve"
            >
                <path
                    fill-opacity="1"
                    stroke-width="0.2"
                    stroke-linejoin="round"
                    d="M 25,52L 51,52L 51,57L 25,57L 25,52 Z M 35,16L 41,16L 41,36.5L 49,27L 49,36.5L 38,49L 27,36.5L 27,27L 35,36.5L 35,16 Z "
                />
            </svg>
            <div>{{ $t('global.DownloadApp') }}</div>
        </a>

        <a v-else-if="isMac && isMobile" href="https://apps.apple.com/lv/app/evesel%C4%ABbaspunkts-ehealthpoint/id910674104" class="button-secondary h-11 relative z-20 my-1 justify-start">
            <svg
                class="h-8 mx-1.5"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                baseProfile="full"
                viewBox="0 0 76.00 76.00"
                enable-background="new 0 0 76.00 76.00"
                xml:space="preserve"
            >
                <path
                    fill-opacity="1"
                    stroke-width="0.2"
                    stroke-linejoin="round"
                    d="M 25,52L 51,52L 51,57L 25,57L 25,52 Z M 35,16L 41,16L 41,36.5L 49,27L 49,36.5L 38,49L 27,36.5L 27,27L 35,36.5L 35,16 Z "
                />
            </svg>
            <div>{{ $t('global.DownloadApp') }}</div>
        </a>

        <div class="hidden relative min-[1400px]:block h-[300px] bg-no-repeat bg-contain rounded-md mb-2 bg-[url(@/images/title-banner/app-bg.png)]">
            <div id="locator"></div>
            <div class="h-[301px] bg-no-repeat rounded-md overflow-hidden bg-contain relative z-20 bg-[url(@/images/title-banner/app-fg.png)]"></div>
        </div>

        <div class="bg-surface shadow-small relative z-20 px-11 py-6 rounded-md">
            <main v-html="$t('global.AppLandingText')"></main>

            <div class="flex flex-col sm:flex-row items-center justify-center mt-4">
                <template v-if="currentLocale == 'lv'">
                    <a class="button-transparent w-40 h-16" href="https://apps.apple.com/lv/app/evesel%C4%ABbaspunkts-ehealthpoint/id910674104">
                        <AppStoreSvg class="!fill-black h-12" />
                    </a>
                    <a class="button-transparent w-40 h-16" href="https://play.google.com/store/apps/details?id=lv.meditec.ehealthpoint&hl=en&utm_source=eveselibaspunkts.lv&utm_campaign=AppLanding&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                        <img alt="ielādēt no Google Play" class="px-2" src="https://play.google.com/intl/en_us/badges/images/generic/lv_badge_web_generic.png" />
                    </a>
                </template>

                <template v-else-if="currentLocale == 'ru'">
                    <a class="button-transparent w-40 h-16" href="https://apps.apple.com/lv/app/evesel%C4%ABbaspunkts-ehealthpoint/id910674104">
                        <AppStoreSvg locale="ru" class="!fill-black h-12" />
                    </a>
                    <a class="button-transparent w-40 h-16" href="https://play.google.com/store/apps/details?id=lv.meditec.ehealthpoint&hl=en&utm_source=eveselibaspunkts.lv&utm_campaign=AppLanding&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                        <img alt="Доступно в Google Play" class="px-2" src="https://play.google.com/intl/en_us/badges/images/generic/ru_badge_web_generic.png" />
                    </a>
                </template>

                <template v-else>
                    <a class="button-transparent w-40 h-16" href="https://apps.apple.com/lv/app/evesel%C4%ABbaspunkts-ehealthpoint/id910674104">
                        <AppStoreSvg locale="en" class="!fill-black h-12" />
                    </a>
                    <a class="button-transparent w-40 h-16" href="https://play.google.com/store/apps/details?id=lv.meditec.ehealthpoint&hl=en&utm_source=eveselibaspunkts.lv&utm_campaign=AppLanding&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                        <img alt="Get it on Google Play" class="px-2" src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png" />
                    </a>
                </template>
            </div>
        </div>
    </evp-layout>
</template>

<script setup>
    import EvpLayout from '@/components/EvpLayout.vue'
    import { route } from 'ziggy'
    import AppStoreSvg from '@/components/AppStoreSvg.vue'
    import NavigationHeader from '@/components/NavigationHeader.vue'

    const isAndroid = window.appData.isAndroid
    const isMac = window.appData.isMac
    const isMobile = window.appData.isMobile

    const currentLocale = window.evp.currentLocale
</script>